module.exports = [
    {
        date: "1998",
        text: ["Institute of automation, Chinese Academy of Sciences takes the lead in iris recognition research in China"],
    },
    {
        date: "2005",
        text: ["Iris image acquisition and recognition technology won the second prize of National Technology Invention Award"],
    },
    {
        date: "2008",
        text: ["Won the first prize of nice I in international iris recognition competition"],
    },
    {
        date: "2010",
        text: ["The first domestic long-distance iris recognition system with working distance of 3 meters has been developed"],
    },
    {
        date: "2013",
        text: ["Taking the lead in the research and development of multi-target iris face system based on computational imaging technology"],
    },
    {
        date: "2015",
        text: ["Tianjin Zhongke intelligent industry technology research institute was established, and the biometrics division was set up at the same time"],
    },
    {
        date: "2016",
        text: ["Mass production and scene application of remote iris face fusion recognition system"],
    },
    {
        date: "2017",
        text: ["Establishment of iristar -- industrialization of major scientific research achievements of Chinese Academy of Sciences"],
    },
    {
        date: "2018",
        text: [
            "Iristar artificial intelligence R & D headquarters officially settled in Zhongguancun, Beijing",
            "Iristar South China operation center and computational imaging module factory are officially located in Shenzhen",
            "In the 9th iris recognition technology test of National Institute of standards and Technology (NIST), we achieved excellent results",
            "China Science and technology Hongxing takes the lead in formulating the national public security iris image quality standard",
            "China Science and technology Hongxing Xinjiang office established in Urumqi",
            "Remote iris recognition technology was selected as \"top 10 domestic technological breakthroughs in 2018\" of science and technology daily, and won the front page headline of China Science Daily",
        ],
    },
    {
        date: "2019",
        text: [
            "W200 and s300-uc are approved as special equipment for iris collection and database construction",
            "Vice Minister of public security visits remote iris recognition products",
            "Establishment of China Science and technology Hongxing Shandong Branch",
            "Join it application innovation Committee",
        ],
    },
    {
        date: "2020",
        text: [
            "All the hardware and software products are made in China",
            "Leading and participating in 4 national standards of biometrics (IRIS)",
            "Put forward the concept of \"real-time scene intelligence\" and start the digital transformation",
            "Application of the company's products in multiple scenarios",
            "Beijing Zhongke Hongxing Intelligent Technology Co., Ltd",
        ],
    },
];